export default "__VITE_ASSET__DsDy6C2P__"